import { gql } from '@apollo/client/core'
import { useMutation } from '@vue/apollo-composable'
import { IUpdateUserFavoritesResponse } from '@types'

const REMOVE_FROM_USER_FAVORITES_MUTATION = gql`
  mutation RemoveUserFavorite($updateUserFavoritesInput: UpdateUserFavoritesInput!) {
    removeUserFavorite(UpdateUserFavoritesInput: $updateUserFavoritesInput) {
      payload {
        ... on StringResponse {
          message
        }
      }
      type
    }
  }
`

export const useRemoveFromUserFavoritesMutation = () => {
  const mutation = useMutation<IUpdateUserFavoritesResponse>(REMOVE_FROM_USER_FAVORITES_MUTATION)
  return mutation
}
